/* eslint-disable max-len */
import {
    Container,
} from '@mui/material';
import { LoggedInUser } from '../../../types/auth.types';
import OdooLiveChat from '../components/OdooLiveChat';
import BuyJobs from '../containers/BuyJobs';
import CustomBR from '../foundation/CustomBR';
import Page from '../layout/base.page';

export type BuyJobsWrapperProps = {
    url: string
    user?: LoggedInUser
}

const BuyJobsWrapper = (props: BuyJobsWrapperProps) => <Page
    url={props.url}
    user={props.user}
    showBackToTop={false}
    pageHeaderTitle="Mploy - פרסום מודעות דרושים" >
    <Container>
        <CustomBR />
        {/* <CenteredFlex>
            <Typography color="secondary" fontWeight="bold" variant="h3">Mploy - פרסום משרות</Typography>
        </CenteredFlex> */}
        <BuyJobs extraDescription={false} />
        {/* <OdooLiveChat /> */}
    </Container>
    <CustomBR />
</Page>;

export default BuyJobsWrapper;
